export const DEFAULT_PRICE_OPTIONS = [
  {
    price: 2,
    entry: 1,
    required: true,
  },
  {
    price: 5,
    entry: 3,
  },
  {
    price: 10,
    entry: 10,
  },
  {
    price: "",
    entry: "",
  },
  {
    price: "",
    entry: "",
  },
  {
    price: "",
    entry: "",
  },
];

export const MAX_WINNERS = 10;
export const DEFAULT_CURRENCY = "USD";

export const FORM_STYLES = {
  labelCol: { style: { fontSize: "18px", fontWeight: "bold" } },
  inputWidth: "50%",
  flexGap: "8px",
  marginBottom: "16px",
};
